<template>
  <div class="centerWidth">
    <div class="tag_position d-flex d-align-center">
      <img src="../assets/images/add1.png" alt="">
      当前位置：<a href="/">首页</a>&gt; <span>关于我们</span>
    </div>
    <div class="dynamic-wrap">
      <div class="tit">{{title}}</div>
      <div class="ql-editor content_wrap_new">
        <div v-html="aboutDetails"></div>
      </div>
    </div>
  </div>
</template>

<script>
	import {
		aboutInfo
	} from "@/api/index";
export default {
  name: "About",
  data() {
    return {
      aboutDetails: '',
	  title:''
    }
  },
  mounted() {
    //关于我们
    this.getAbout()
  },
  methods: {
    getAbout() {
      let ajaxData = { }
      aboutInfo(ajaxData).then(res => {
        if (res.code == 1) {
          this.aboutDetails = res.data.content
		   this.title = res.data.title
        }
      })
    },
  }
}
</script>

<style scoped lang="scss">
.dynamic-wrap {
  background: #fff;
  width: 100%;
  .tit{
    margin-top: 30px;
    color: #2257ab;
    font-size: 30px;
    font-weight: bold;
    text-align: center;
    padding: 30px 0;
    border-bottom: 1px solid #eee;
  }
}

.dynamic-wrap .dynamic-content-wrap {
  padding: 30px;
  width: 100%;
}

</style>
